import React, { useCallback, useEffect } from 'react';
import { useStoreSelector } from 'v3/data/store';
import { setStoreIdsListFilter, setAllStoresIds } from 'v3/data/store/payment/actions';
import { showErrorDialog } from 'v3/data/store/error/actions';
import { getStorePermissions, setStoreList } from 'v3/data/store/stores/actions';
import { StoreProfileEnum } from 'v3/data/store/stores/enums';
import { IStoreItem } from 'v3/data/store/stores/types';
import * as api from 'v3/services/api';
import { CommonTemplate } from 'v3/shared/templates/CommonTemplate';
import { HeadlineMedium } from 'v3/shared/typography/HeadlineMedium';
import { Container, Content, Header, TitleContainer } from './styles';
import { PaymentsFilter } from 'v3/shared/components/Filters/PaymentsFilter';
import { PaymentsTable } from 'v3/shared/components/Table/PaymentsTable';

export const PaymentsPage = () => {
  const { group, profileId, id, storeUserId } = useStoreSelector((store) => store.store.storeLogged);
  const { isMaster } = getStorePermissions();
  const { filter } = useStoreSelector((store) => store.contracting);
  const { initialStoreIds } = useStoreSelector((store) => store.contracting.generateAllContractingList);

  const extractStoreIds = (data: IStoreItem[]) => {
    return data.map((store) => store.id);
  };

  const getInitialStoreIds = useCallback(async () => {
    const response = await api.getStores({ group, profileId, storeUserId });
    const storeIds = extractStoreIds(response.data);
    setStoreIdsListFilter(storeIds);
    const storeListFormatted = response.data.map((item) => ({
      ...item,
      checked: true,
    }));
    if (initialStoreIds.length === 0) {
      setAllStoresIds(storeListFormatted);
    }
  }, [group, profileId, storeUserId, initialStoreIds.length]);

  useEffect(() => {
    if (isMaster) {
      getInitialStoreIds();
    }
  }, [getInitialStoreIds, isMaster]);

  const fetchStoreIdsList = useCallback(async () => {
    try {
      const response = await api.getStores({ group, profileId, storeUserId });
      const storeIds = extractStoreIds(response.data);
      setStoreIdsListFilter(storeIds);
      const storeListFormatted = response.data.map((item) => ({
        ...item,
        checked: true,
      }));

      setAllStoresIds(storeListFormatted);
      setStoreList(storeListFormatted);
    } catch (error) {
      showErrorDialog('Erro ao obter lista de lojas', error);
    }
  }, [group, profileId, storeUserId]);

  useEffect(() => {
    if (filter.storeIds.length === 0 && id && group !== StoreProfileEnum.STORE) {
      fetchStoreIdsList();
    }
  }, [id, fetchStoreIdsList, filter.storeIds.length, group]);

  return (
    <CommonTemplate>
      <Container>
        <Content>
          <Header>
            <TitleContainer>
              <HeadlineMedium>Lista de pagamentos de parcelas</HeadlineMedium>
            </TitleContainer>
          </Header>
          <PaymentsFilter />
          <PaymentsTable />
        </Content>
      </Container>
    </CommonTemplate>
  );
};
